module.exports = __webpack_public_path__ + "img/login2.0511fd88.png";